<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
      >
        <template-select
          v-model="templateModel"
          :templates="templates"
        />

        <filter-buttons
          :filters="appliedFilters"
          @filter-removed="removeFilter"
        />

        <collection-filters
          :filters="filters"
          :active-filters="appliedFilters"
          @filters-submitted="submitFilters"
          @filters-cleared="clearFilters"
        />
      </v-flex>
      <v-flex xs12>
        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <page-data-table-row
              :props="props" />
          </template>

          <template slot="no-data">
            <v-btn
              color="primary"
              @click="clearFilters"
            >
              {{ $t('Reset') }}
            </v-btn>
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import PageDataTableRow from '@/modules/CMS/components/PageDataTableRow'
import CollectionFilters from '@/vuetify-console/components/CollectionFilters'
import MassActionSelect from '@/vuetify-console/components/MassActionSelect'
import FilterButtons from '@/vuetify-console/components/FilterButtons'
import TemplateSelect from '@/modules/CMS/components/TemplateSelect'

const { mapActions, mapGetters } = createNamespacedHelpers('cms/pages')

export default {
  name: 'TemplateList',

  components: {
    TemplateSelect,
    MassActionSelect,
    CollectionFilters,
    PageDataTableRow,
    FilterButtons
  },

  actionBar () {
    return {
      title: 'Pages',
      actions: [
        {
          text: 'Add new page',
          event: 'create',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      selected: [],
      code: null
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta', 'appliedFilters', 'templateCode', 'templates']),

    createActionStates () {
      return {
        disabled: !this.templateCode,
        loading: this.loading
      }
    },

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        if (!this.templates || !this.templates.length) {
          return
        }

        this.applyMeta(value)
      }
    },

    templateModel: {
      get: function () {
        return this.templateCode
      },
      set: function (code) {
        this.setTemplate(code)
      }
    },

    headers () {
      return [
        { text: this.$t('Slug'), value: 'slug' },
        { text: this.$t('Name'), value: 'name', width: '100%' },
        { text: this.$t('Type'), value: 'type', class: 'text-xs-right' },
        { text: this.$t('Protected'), value: 'protected', class: 'text-xs-center' },
        { text: this.$t('Created at'), value: 'created_at', width: '1%', class: 'text-xs-right' },
        { text: this.$t('Updated at'), value: 'updated_at', width: '1%', class: 'text-xs-right' }
      ]
    },

    filters () {
      return [
        { field: 'slug', type: 'string', label: this.$t('Slug') },
        { field: 'name', type: 'string', label: this.$t('Name') },
        { field: 'type', type: 'string', label: this.$t('Type') }
      ]
    }
  },

  async created () {
    if (!this.templates.length) {
      await this.fetchTemplates()

      if (this.templates.length) {
        this.fetchCollection()
      }
    }
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection', 'removeFilter', 'clearFilters', 'fetchTemplates', 'setTemplate']),

    setSearchQuery (query) {
      this.searchQuery = query
    },

    onActionCreate () {
      this.$router.push({ name: 'new-page', query: { code: this.templateCode } })
    },

    submitFilters (filters) {
      this.applyMeta({ filters })
    }
  }
}
</script>
